import { useFormikContext } from "formik";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { BorderBox, Loader, SELECT_OPTION } from "../../../Helpers/Helpers";
import { Autocomplete, Box, FormControl, List, ListItemButton, ListItemText, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { use, useEffect, useState } from "react";
import { getCorporationDetails, getPCList } from "../../../API/nimbleAPI";
import { enqueueSnackbar } from "notistack";
import ViewTransactionsRanges from "../../../Components/CustomeDateRange";
import dayjs from 'dayjs';
import { DatePicker } from 'antd';
import 'antd/dist/reset.css';
import OutlinedSelectButton from "../../../Components/SelectionButton";
import ManagementDialog from "./ManagementDialog";


import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const getFiscalPeriodInfo = async (corpId) => {
    const response = await getCorporationDetails(corpId);

    const currentYear = dayjs().year();

    const start = dayjs(
        `${currentYear}/${response.PeriodStartDate}`,
        "YYYY/MM/DD"
    );

    let end = dayjs(
        `${currentYear}/${response.PeriodEndDate}`,
        "YYYY/MM/DD"
    );

    if (end.isBefore(start)) {
        end = end.add(1, "year");
    }

    return {
        ...response,
        fiscalStartDate: start.toDate(),
        fiscalEndDate: end.toDate()
    };
};

const FilterPanel = ({ statementTypeList }) => {

    const SELECT_ID = "000000000000000000000000000000000000"

    const { state } = useLocation();
    const navigate = useNavigate();
    const { RangePicker } = DatePicker;
    // const transactionRanges = ViewTransactionsRanges();
    const outletContext = useOutletContext();
    const { reportConfiguration, headerCorpId, showreport, rediskey, previleges } = outletContext;
    const { values, handleChange, setFieldValue } = useFormikContext();
    const [managementGroupDialog, setManagementGroupDialog] = useState(false);
    const [useNavigationState, setUseNavigationState] = useState(true)

    const [periodInfo, setPeriodInfo] = useState(null);
    const transactionRanges = ViewTransactionsRanges(periodInfo);

    const allCorpList = reportConfiguration?.corpList || [];

    const filteredCorpList =
        Number(values.statementType) === 3
            ? allCorpList.filter(item => item.isPcCorps === true)
            : allCorpList;

    const corpList = [
        SELECT_OPTION,
        ...new Map(
            filteredCorpList.map(item => [item.id, item])
        ).values()
    ];


    const managementOptions = Object.entries(
        reportConfiguration?.managementGroups || {}
    ).map(([key, value]) => ({
        label: key === "All" ? "-All Properties-" : key,
        value: key,
        disabled: value === SELECT_ID,
    }));
    const order = [
        { key: "Summary", label: "Summary" },
        { key: "Details", label: "Details" },
        { key: "Summary & Details", label: "Both" }
    ];

    const [pcList, setPcList] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if ((Number(values.statementType) === 1 || Number(values.statementType) === 2) && values.selectedManagementGroups === "All") {

            // using when state data while navigation and reset
            if (useNavigationState && state?.userSelections) {
                setFieldValue("corporationDetails", state.userSelections.corporationDetails);
                setFieldValue("selectedCrpCount", state.userSelections.selectedCrpCount);
                setUseNavigationState(false);
                return;
            }
            let selectAllCrp = [];
            if (headerCorpId && headerCorpId !== SELECT_ID) {
                selectAllCrp = reportConfiguration?.corpList.filter(corp => corp.id === headerCorpId);
            } else {
                selectAllCrp = reportConfiguration?.corpList;
            }
            setFieldValue("corporationDetails", selectAllCrp);

            setFieldValue("selectedCrpCount", {
                selected: selectAllCrp.length || 0,
                total: reportConfiguration?.corpList?.length || 0
            });

        }

        if ((Number(values.statementType) === 0 || Number(values.statementType) === 3) && values.corporationIds?.length > 0) {
            const selectedCorpDetails =
                values.corporationIds[0]
                    ? corpList.find(c => c.id === values.corporationIds[0])
                    : null;

            setFieldValue("corporationDetails", selectedCorpDetails ? [selectedCorpDetails] : []);
            setFieldValue("corporationIds", selectedCorpDetails ? [selectedCorpDetails?.id] : []);
            setFieldValue("selectedCrpCount", {
                selected: "",
                total: ""
            });
            if (values.corporationIds[0] !== SELECT_ID && values.corporationIds[0] !== "select") {
                loadCorporationPeriod(values.corporationIds[0]);
                // fetchprofitCenters();
                return;
            }
            setUseNavigationState(false);
        }

    }, [values.statementType, values.selectedManagementGroups]);

    useEffect(() => {
        setFieldValue("profitCenterDetails", "")
        const corpId = values.corporationIds?.[0];
        if (!corpId || corpId === SELECT_ID || corpId === "select") return;
        fetchprofitCenters();
    }, [values.corporationIds]);

    useEffect(() => {
        const init = async () => {

            if (
                showreport === "showreport" &&
                rediskey &&
                values.redisKeyConfigData?.FromDate &&
                values.redisKeyConfigData?.Todate
            ) {
                const fromDate = dayjs(
                    values.redisKeyConfigData.FromDate,
                    [
                        "M/D/YYYY",
                        "MM/DD/YYYY",
                    ]
                );

                const toDate = dayjs(
                    values.redisKeyConfigData.Todate,
                    [
                        "M/D/YYYY",
                        "MM/DD/YYYY",
                    ]
                );
                setFieldValue("viewTransaction", "Range");

                setFieldValue("dateRange", [
                    fromDate.startOf("day"),
                    toDate.endOf("day"),
                ]);

                return;
            }

            const dateRange = transactionRanges.find(
                (r) => r.date === values.viewTransaction
            );

            if (!values.dateRange?.length && dateRange) {

                setFieldValue("viewTransaction", dateRange.date);

                setFieldValue("dateRange", [
                    dateRange.actualValue.start,
                    dateRange.actualValue.end,
                ]);
            }
        };

        init();
    }, []);

    const fetchprofitCenters = async () => {
        try {
            setLoading(true)
            const pc = await getPCList(values.corporationIds[0]);
            // setPcList(pc);
            if (Array.isArray(pc) && pc.length > 0) {
                const withAll = [{ ID: "all", Name: "All" }, ...pc];
                setPcList(withAll);

                if (useNavigationState && state?.userSelections) {
                    setFieldValue("profitCenters", values.profitCenters);
                    if (pc.length === values.profitCenters.length) {
                        setFieldValue("profitCenterDetails", "All");
                    } else {
                        setFieldValue("profitCenterDetails", "");
                    }
                    setUseNavigationState(false);
                    return;
                }
                setFieldValue("profitCenters", pc.map(item => item.ID));
                setFieldValue("profitCenterDetails", "All");
            } else {
                setPcList([]);
                setFieldValue("profitCenters", []);
                setFieldValue("profitCenterDetails", "");
            }

        } catch (error) {
            enqueueSnackbar("Error to get Profit Center List", { variant: "error" });
        } finally {
            setLoading(false)
        }
    };

    const onViewChange = (val) => {
        const match = transactionRanges.find(r => r.date === val);
        setFieldValue("viewTransaction", val);
        setFieldValue("dateRange", [match.actualValue.start, match.actualValue.end]);
    };

    const onDateChange = (dates) => {
        if (!dates) return;

        setFieldValue(
            "dateRange",
            dates.map(d => d.toDate())
        );
        setFieldValue("viewTransaction", "Range");
    };

    const ProfitCenterList = ({
        title = "Profit Centers",
        data = [],
        selectedIds = [],
        onItemClick,
    }) => {
        return (
            <Box
                sx={{
                    height: 120,
                    backgroundColor: "#e8e8e8",
                    p: 1,
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 1,
                    border: "1px solid lightgrey"
                }}
            >
                <Typography
                    fontSize={10}
                    color="text.secondary"
                // mb={0.5}
                >
                    {title}
                </Typography>

                <Box sx={{ flex: 1, overflowY: "auto" }}>
                    <List dense disablePadding>
                        {Array.isArray(data) &&
                            data.map((item) => (
                                <ListItemButton
                                    key={item.ID}
                                    // selected={selectedIds.includes(item.ID)}
                                    selected={
                                        item.ID === "all"
                                            ? data
                                                .filter(d => d.ID !== "all")
                                                .every(d => selectedIds.includes(d.ID))
                                            : selectedIds.includes(item.ID)
                                    }
                                    // selected={
                                    //     values.profitCenterDetails === "All"
                                    //         ? item.ID === "all"
                                    //         : selectedIds.includes(item.ID)
                                    // }
                                    onClick={() => onItemClick(item.ID)}
                                    sx={{
                                        px: 1,
                                        py: 0.5,
                                        "&.Mui-selected": {
                                            backgroundColor: "#767676",
                                            color: "white",
                                        },
                                        "&.Mui-selected:hover": {
                                            backgroundColor: "#767676",
                                            color: "white",
                                        },
                                    }}
                                >
                                    <ListItemText
                                        primary={item.Name}
                                        primaryTypographyProps={{ fontSize: 12 }}
                                    />
                                </ListItemButton>
                            ))}
                    </List>
                </Box>
            </Box>
        );
    };

    const handleProfitCenterClick = (id) => {
        const allIds = pcList
            .filter(pc => pc.ID !== "all")
            .map(pc => pc.ID);

        let updated = [];

        if (id === "all") {
            updated = allIds;

            setFieldValue("profitCenters", updated);
            setFieldValue("profitCenterDetails", "All");
            return;
        }

        // If currently "All" is selected, switch to only clicked PC
        if (values.profitCenterDetails === "All") {
            updated = [id];
        } else {
            if (values.profitCenters.includes(id)) {
                // Don't allow deselecting the last selected PC
                if (values.profitCenters.length === 1) {
                    return;
                }
                updated = values.profitCenters.filter(x => x !== id);
            } else {
                updated = [...values.profitCenters, id];
            }
        }

        setFieldValue("profitCenters", updated);

        const totalPC = allIds.length;

        if (updated.length === 0) {
            setFieldValue("profitCenterDetails", "");
        } else if (updated.length === totalPC) {
            setFieldValue("profitCenterDetails", "All");
        } else if (updated.length === 1) {
            const pcName = pcList.find(pc => pc.ID === updated[0])?.Name || "";
            setFieldValue("profitCenterDetails", pcName);
        } else {
            setFieldValue("profitCenterDetails", "Multiple");
        }
    };

    const getDate = (value) => {
        if (!value) return value;

        return typeof value?.toDate === "function"
            ? value.toDate()
            : value instanceof Date
                ? value
                : new Date(value);
    };
    const loadCorporationPeriod = async (corpId) => {
        try {
            const periodData = await getFiscalPeriodInfo(corpId);
            const transactions = ViewTransactionsRanges(periodData);
            const prevDateTypes = transactions.find(r => r?.date === values?.viewTransaction);


            if (periodData && periodData?.IsFisicalOrFinancial === 0) {
                if (prevDateTypes.date === "Range") {
                    if (!showreport && !rediskey) {
                        setFieldValue("dateRange", values.dateRange);
                    }
                    // setFieldValue("dateRange", values.dateRange);
                    setFieldValue("viewTransaction", prevDateTypes.date);
                } else {
                    setFieldValue("dateRange", [getDate(prevDateTypes.actualValue?.start), getDate(prevDateTypes?.actualValue?.end)]);
                    setFieldValue("viewTransaction", prevDateTypes.date);
                }
                setPeriodInfo(periodData);
                return periodData;
            }
            setPeriodInfo(periodData);
            if (prevDateTypes.date === "Range") {
                if (!showreport && !rediskey) {
                    setFieldValue("dateRange", values.dateRange);
                }
                // setFieldValue("dateRange", values.dateRange);
                setFieldValue("viewTransaction", prevDateTypes.date);
            } else {

                setFieldValue("dateRange", [getDate(prevDateTypes.actualValue?.start), getDate(prevDateTypes?.actualValue?.end)]);
                setFieldValue("viewTransaction", values?.viewTransaction);
            }
            return periodData;
        } catch (error) {
            console.log(error)
            enqueueSnackbar(
                "Failed to load corporation period",
                { variant: "error" }
            );
            return null;
        }
    };

    const statementTypeOptions = {
        all: [
            { value: 0, label: "Regular" },
            { value: 1, label: "Combined Corporation" },
            { value: 3, label: "Combined PC" },
            { value: 2, label: "Consolidated" },
        ],
        combined: [
            { value: 1, label: "Combined Corporation" },
            { value: 3, label: "Combined PC" },
        ],
        default: [
            { value: 0, label: "Regular" },
            { value: 2, label: "Consolidated" },
        ],
    };

    const options = statementTypeOptions[statementTypeList]
        ?? statementTypeOptions.all;
    return (
        <>
            <Stack height={"100%"} width={"100%"} gap={2}>
                <BorderBox >
                    <Typography mb={1} fontWeight={400} color="text.secondary" fontSize={11}>Income Statement</Typography>
                    {statementTypeList && (
                        <Select
                            variant="filled"
                            name="statementType"
                            value={values.statementType ?? ""}
                            // onChange={handleChange}
                            onChange={async (e) => {
                                const value = Number(e.target.value)
                                setFieldValue("statementType", value);

                                setPcList([]);
                                setFieldValue("profitCenters", []);
                                setFieldValue("profitCenterDetails", "");

                                if ((value === 0 || value === 3) && values.corporationIds?.length > 0 && values.corporationIds[0] !== SELECT_ID && values.corporationIds[0] !== "select") {
                                    await loadCorporationPeriod(values.corporationIds[0])
                                } else {
                                    setPeriodInfo(null);
                                    const transactionss = ViewTransactionsRanges(null);
                                    const ytd = transactionss.find(r => r.date === "This Year – to – Date");
                                    setFieldValue("dateRange", [ytd.actualValue?.start?.toDate(), ytd?.actualValue?.end?.toDate()]);
                                    setFieldValue("viewTransaction", ytd.date);
                                }
                                // if (value !== 1) {
                                if (value === 0 || value === 2) {
                                    const isCheckDefault = (reportConfiguration?.columnTypes || []).find(
                                        item => item.isDefault === true
                                    );
                                    const combinedORregular = isCheckDefault || reportConfiguration?.columnTypes?.[0]
                                    // const combined = reportConfiguration.columnTypes.find(item => item.displayId === 1);

                                    setFieldValue("columnsBy", combinedORregular)
                                    setFieldValue("columnSelections", []);
                                } else {
                                    setFieldValue("columnSelections", []);
                                    const combined = reportConfiguration.columnTypes.find(item => item.displayId === 6);
                                    setFieldValue("columnsBy", combined)
                                }
                            }}
                            fullWidth
                        >
                            {/* <MenuItem value={0}>Regular</MenuItem>
                        <MenuItem value={1}>Combined Corporation</MenuItem>
                        <MenuItem value={3}>Combined PC</MenuItem>
                        <MenuItem value={2}>Consolidated</MenuItem> */}
                            {options.map(({ value, label }) => (
                                <MenuItem key={value} value={value}>
                                    {label}
                                </MenuItem>
                            ))}
                        </Select>
                    )}
                </BorderBox>
                <BorderBox gap={3} height={"100%"}>

                    {(values.statementType === 0 || values.statementType === 3) &&
                        <Autocomplete
                            fullWidth
                            options={corpList}
                            size="small"
                            disableClearable
                            value={
                                corpList.find(
                                    (corp) => corp.id === values.corporationIds?.[0]
                                ) || SELECT_OPTION
                            }
                            onChange={async (event, newValue) => {
                                setFieldValue("corporationIds", [newValue.id]);
                                setFieldValue("corporationDetails", [newValue]);
                                if (newValue?.id === "select") {

                                    // setFieldValue("dateRange", []);
                                    // setFieldValue("viewTransaction", "-Select Period-");

                                    return
                                };
                                await loadCorporationPeriod(newValue.id);
                            }}
                            // getOptionLabel={(option) => option.corporationName}
                            getOptionLabel={(option) =>
                                option.isLegalName ? option.legalName : option.corporationName
                            }
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="filled"
                                    label="Corporation"
                                    placeholder="-Select-"
                                />
                            )}
                        />}
                    {/* {values.statementType !== 0 && */}
                    {(values.statementType === 1 || values.statementType === 2) &&
                        <>
                            <Autocomplete
                                fullWidth
                                options={managementOptions}
                                size="small"
                                disableClearable
                                value={
                                    managementOptions.find(
                                        (opt) => opt.value === values.selectedManagementGroups
                                    ) || null
                                }
                                // onChange={(event, newValue) => {
                                //     if (newValue?.disabled) return;
                                //     setFieldValue("selectedManagementGroups", newValue?.value || "");
                                // }}
                                onChange={(event, newValue) => {
                                    if (newValue?.disabled) return;

                                    const selectedValue = newValue?.value || "";
                                    setUseNavigationState(false);

                                    setFieldValue("selectedManagementGroups", selectedValue);

                                    const corpList = reportConfiguration?.corpList || [];

                                    if (!selectedValue || selectedValue === "All") {
                                        setFieldValue("corporationDetails", []);
                                        setFieldValue("selectedCrpCount", {
                                            selected: '',
                                            total: ''
                                        });
                                        return;
                                    }

                                    const matchedList = corpList.filter((corp) => {
                                        return (
                                            corp.propertyType === selectedValue ||
                                            corp.service === selectedValue ||
                                            corp.brand === selectedValue ||
                                            corp.pms === selectedValue
                                        );
                                    });

                                    setFieldValue("corporationDetails", matchedList);

                                    setFieldValue("selectedCrpCount", {
                                        selected: matchedList.length,
                                        total: matchedList.length
                                    });
                                }}
                                getOptionLabel={(option) => option.label}
                                isOptionEqualToValue={(option, value) => option.value === value.value}
                                getOptionDisabled={(option) => option.disabled}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="filled"
                                        label="Management Group"
                                    // placeholder="-Select-"
                                    />
                                )}
                            />

                            <TextField
                                fullWidth
                                size="small"
                                variant="filled"
                                label="Corporations"
                                value={
                                    values.selectedCrpCount.total !== 0 &&
                                        values.selectedCrpCount.selected === values.selectedCrpCount.total
                                        ? "All Corporation(s) selected"
                                        : `${values.selectedCrpCount.selected || 0} Corporation(s) selected`
                                }
                                InputProps={{
                                    readOnly: true
                                }}
                                sx={{
                                    cursor: "pointer",
                                    "& .MuiInputBase-input": {
                                        cursor: "pointer"
                                    }
                                }}
                                onClick={() => setManagementGroupDialog(true)}
                            />
                        </>

                    }



                    {/* {Array.isArray(pcList) && pcList.length > 0 && values.statementType === 0 && */}
                    {Array.isArray(pcList) && pcList.length > 0 && (values.statementType === 0 || values.statementType === 3) &&
                        <ProfitCenterList
                            data={Array.isArray(pcList) ? pcList : []}
                            selectedIds={values.profitCenters}
                            onItemClick={handleProfitCenterClick}
                        />}



                    <Autocomplete
                        options={transactionRanges.map(r => r.date)}
                        size="small"
                        disableClearable
                        value={values.viewTransaction}
                        onChange={(e, v) => onViewChange(v)}
                        renderInput={(p) => (
                            <TextField {...p} label="View Transaction" variant="filled" />
                        )}
                    />
                    <Box >

                        <RangePicker
                            classNames={{
                                popup: {
                                    root: "small-range-picker",
                                },
                            }}
                            size={"large"}
                            // format="MM/DD/YYYY"
                            format={["MM/DD/YYYY", "MMDDYYYY"]}
                            style={{
                                width: "100%",
                                backgroundColor: "#f5f5f5",
                                borderRadius: 4,
                            }}
                            placeholder={["From date", "To date"]}
                            value={
                                values.dateRange?.[0]
                                    ? [dayjs(values.dateRange[0]), dayjs(values.dateRange[1])]
                                    : null
                            }
                            onChange={onDateChange}
                            // onBlur={onDateBlur}
                            onCalendarChange={onDateChange}
                            order={false}
                        />
                        <Typography
                            sx={{
                                position: "relative",
                                top: "-39px",
                                left: "12px",
                                fontSize: "9px",
                                color: "text.secondary",
                            }}
                        >
                            From & To
                        </Typography>
                    </Box>

                    <Stack direction="row" gap={0.5} width="100%" flexWrap="wrap">
                        {order.map(({ key, label }) => {
                            const item = reportConfiguration.reportType.list.find(r => r.name === key);
                            if (!item) return null;

                            return (
                                <OutlinedSelectButton
                                    key={item.id}
                                    label={label}
                                    selected={values.reportType === item.id}
                                    onClick={() => {
                                        if (values.reportType === item.id) {
                                            return;
                                        };
                                        if (previleges && previleges?.Update === false) {
                                            enqueueSnackbar("You don't have update Permission.", { variant: "warning" });
                                            return;
                                        };
                                        setFieldValue("reportType", item.id)
                                    }}
                                // width="115px"
                                />
                            );
                        })}
                    </Stack>

                    <Stack direction="row" gap={0.5} flexWrap="wrap">
                        {reportConfiguration.accuralOrCashType.list.map(item => (
                            <OutlinedSelectButton
                                key={item.id}
                                label={item.name}
                                selected={values.basis === item.id}
                                onClick={() =>
                                    setFieldValue("basis", item.id)
                                }
                            />
                        ))}
                    </Stack>

                </BorderBox>
            </Stack>
            <Loader loading={loading} />
            {managementGroupDialog &&
                <ManagementDialog
                    open={managementGroupDialog}
                    onClose={() => setManagementGroupDialog(false)}
                    managementOptions={managementOptions}
                />}
        </>
    )


};

export default FilterPanel;

